import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import ActionCreator from "../../store/actions/index";
import { compose } from 'recompose';
import { withStyles, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { themeTypeToBool } from '../../utils/helpers';
import t from "../../languages/pl";

const useStyles = theme => ({
    container: {
    },
    formControl: {
        minWidth: 140,
        margin: theme.spacing(1),
    },
    input: {
        fontSize: 15,
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? theme.palette.common.black : theme.palette.common.white,
    },
    textFieldRoot: {
        marginTop: 2.5
    },
    noOptions: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "inherit"
    }
});

const Search = props =>  {
    const { classes, cars = null, selectedCar = null, onSearchFieldChange, searchValue, onSearchStart, disableSelect = false } = props;
    const [displaySearch, setSearch] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setSearch(searchValue);
    }, [searchValue]);

    const handleAutocompleteChange = (event, value) => {
        if (value && value !== selectedCar){
            props.setSelectedCar(value);
        }
        else {
            props.clearSelectedCar();
            props.clearRoutes();
        }
    };

    const handleKeyUp = e => {
        if(e.key === "Enter"){
            if(onSearchStart)
                onSearchStart();
        }
    };

    const handleTextChange = e => {
        onSearchFieldChange(e.target.value);
    };

    return (
        <div className={classes.container}>
            <Autocomplete
                options={cars}
                noOptionsText={t.noResultsInfo}
                classes={{ root: classes.formControl, noOptions: classes.noOptions }}
                value={selectedCar}
                inputValue={selectedCar ? selectedCar.rejestracja : displaySearch}
                onChange={handleAutocompleteChange}
                getOptionLabel={option => option ? option.rejestracja : displaySearch}
                renderOption={(option) => (
                    <React.Fragment>
                        {option.rejestracja}
                    </React.Fragment>
                )}
                open={!disableSelect && open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                popupIcon={!disableSelect ? undefined : null}
                renderInput={params => (
                    <TextField
                        {...params}
                        classes={{root: classes.textFieldRoot}}
                        InputLabelProps={{
                            shrink: true,
                            classes: { root: classes.label }
                        }}
                        label={t.find}
                        variant="standard"
                        fullWidth
                        size="small"
                        onChange={handleTextChange}
                        onKeyUp={handleKeyUp}
                    />
                )}
            />
        </div>
    );
};

const mapStateToProps = state => {
    return {
        selectedCar: state.mapCarsReducer.selectedCar,
        cars: state.mapCarsReducer.cars,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(useStyles)
)(Search);

Search.propTypes = {
    classes: PropTypes.object,
    searchValue: PropTypes.string,
    disableSelect: PropTypes.bool,
    onSearchFieldChange: PropTypes.func,
    onSearchStart: PropTypes.func,
    //redux props
    selectedCar: PropTypes.object,
    cars: PropTypes.array,
    setSelectedCar: PropTypes.func,
    clearSelectedCar: PropTypes.func,
    clearRoutes: PropTypes.func,
    search: PropTypes.func
};